import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Grid } from 'react-bootstrap';
import * as TF from '../../service/tradeflow';
import * as DTO from '../../service/DTOs';
import * as Session from '../../service/Session';
import * as Dispatch from '../../service/Dispatcher';
import * as RB from 'react-bootstrap';

import { Link, NavLink } from 'react-router-dom';
//import { TextChat } from '../TextChat';
import { LimitsSettings } from '../LimitsSettings';

import { ImpactorChatWidget } from '../impactor/ImpactorChatWidget';
import { ImpactorChat } from '../impactor/ImpactorChat';




type LoginPartProps = LoginPartState & { xsrfToken?: string };

const initialstate: LoginPartState = {
    user: { identityState: Session.AnonimousIdentityState },
    syshdr: { hasfreshchanges: false, sstamp: '' },
    tmessages: [],
    appId: 0,
    sharedChatId: 0,
    chatactivity: []
}

interface LoginPartState {
    syshdr: DTO.SystemHeader;
    user: Session.UserState;
    tmessages: DTO.AgentTextMessage[];
    isChatPanelVisible?: boolean;
    isChatPanel2Visible?: boolean;
    isLimitsPanelVisible?: boolean;
    appId: number;
    sharedChatId?: number;
    chatactivity: DTO.AgentChatActivity[];
}

export class LoginPart extends React.Component<LoginPartProps, LoginPartState> {
    constructor(props: LoginPartProps) {
        super(props);

        this.state = {
            ...initialstate, ...{ user: props.user }, ...{ isChatPanelVisible: false }, ...{ isChatPanel2Visible: false },
            ...{ isLimitsPanelVisible: false }, ...{ syshdr: props.syshdr }, ...{ tmessages: props.tmessages }
        }        
    }

    componentWillReceiveProps(nextProps: LoginPartProps) {
        this.setState({ user: nextProps.user });
        this.setState({ syshdr: nextProps.syshdr });
        this.setState({ tmessages: nextProps.tmessages });
        this.setState({ appId: nextProps.appId });
        this.setState({ sharedChatId: nextProps.sharedChatId });        
        this.setState({ chatactivity: nextProps.chatactivity });
        
    }

    //componentWillReceiveProps(nextProps: LoginPartProps) {
    //    console.log('componentWillReceiveProps');
    //    console.log(nextProps);

    //    //this.setState({
    //    //    // set something 
    //    //});
    //}

    //componentDidMount() {
    //    console.log('mount props');
    //    console.log(this.props.user);
    //}

    getState =  () => {
        return this.state;
    }

    dispatch = (action: Session.LoginAction) => {
        return Dispatch.LoginDispatcher(this, action);
    }

    _logout = (e: any) => {
        Session.accountActions.logout(this.getState, this.dispatch);
    }

    updateChatModal(isVisible: boolean) {
        this.setState({ isChatPanelVisible: isVisible })

        if (!isVisible) {
            //TF.PublishCommandForceAgentFrame();
            TF.PublishCommand('COMMAND.State.NewMessagesRead', {});
            
        }
    }

    updateChat2Modal(isVisible: boolean) {
        this.setState({ isChatPanel2Visible: isVisible })

        if (!isVisible) {
            TF.PublishCommand('COMMAND.State.NewMessagesRead', {});

        }
    }

    updateLimitsModal(isVisible: boolean) {
        this.setState({ isLimitsPanelVisible: isVisible })

        if (!isVisible) {
            //TF.PublishCommandForceAgentFrame();

            let uiCtx: DTO.UserInteractionContext = {
                selected_cmp: undefined,
                selected_locatorId: undefined
            }

            TF.PublishCommand('COMMAND.UI.UserInteractionCtx', uiCtx);
        }
    }

    renderLoggedOut() {
        return <ul className="nav navbar-nav navbar-right" style={{ paddingRight: '28px' }}>
            <li>
                <NavLink to={'/login'} activeClassName='active' className='linkbtn'> 
                    <span className='glyphicon glyphicon glyphicon-log-in'></span>Войти
                </NavLink>
            </li>
        </ul>;
    }

    renderLoggedIn() {
        let is_trade = this.state.user.identityState.isTrader;
        let is_deals = this.state.user.identityState.isRepoTrader;

        let userDisplay = '';

        if (this.state.user.personalState) {
            userDisplay = (this.state.user.personalState.lastName || '') + ' ' + (this.state.user.personalState.firstName || '') + ' ' + (this.state.user.personalState.sureName || '');
            if (userDisplay.length < 5) {
                userDisplay = this.state.user.personalState ? this.state.user.personalState.email : '';
            }
            if (this.state.user.personalState.entity) {
                userDisplay = userDisplay + ' - ' + this.state.user.personalState.entity.shortname;
            }
        }
        else {
            userDisplay = this.state.user.identityState.userName;
        }

        if (!userDisplay || userDisplay.trim().length == 0)
            userDisplay = '<Undefined>';

        //<button type="submit" className="btn-link navbar-btn navbar-link">
        //    <span className='glyphicon glyphicon glyphicon-log-out'></span>Выход
        //            </button>


        //let chatWindow = <RB.Modal className='menu-sidebar right' style={{ width: '500px' }} show={this.state.isChatPanelVisible} onHide={() => this.updateChatModal(false)} autoFocus keyboard>
        //    <RB.Modal.Header closeButton>
        //        <RB.Modal.Title>{'Обмен сообщениями - общий чат'}</RB.Modal.Title>
        //    </RB.Modal.Header>
        //    <RB.Modal.Body>
        //        <TextChat xsrfToken={this.props.xsrfToken} {...this.props} {...this.state} messages={[]} idchat={this.state.sharedChatId} />
        //    </RB.Modal.Body>
        //</RB.Modal>


        let chat2Window =
            is_deals ?
                <RB.Modal className='menu-sidebar right' style={{ width: '750px' }} show={this.state.isChatPanel2Visible} onHide={() => this.updateChat2Modal(false)} autoFocus keyboard>
                    <RB.Modal.Header closeButton>
                        <RB.Modal.Title>{'Message Impactor (Чат)'}</RB.Modal.Title>
                    </RB.Modal.Header>
                    <RB.Modal.Body>
                        <ImpactorChatWidget xsrfToken={this.props.xsrfToken} {...this.props} {...this.state} shareChatId={this.state.sharedChatId} new_messages={this.state.tmessages} />
                    </RB.Modal.Body>
                </RB.Modal>
                : undefined;


        let limitsWindow =
            is_deals ?
                <RB.Modal className='menu-sidebar bottom' style={{ height: '600px' }} show={this.state.isLimitsPanelVisible} onHide={() => this.updateLimitsModal(false)} autoFocus keyboard>
                    <RB.Modal.Header closeButton>
                        <RB.Modal.Title>{'Настройка лимитов'}</RB.Modal.Title>
                    </RB.Modal.Header>
                    <RB.Modal.Body>
                        <LimitsSettings xsrfToken={this.props.xsrfToken} {...this.props} {...this.state} {...{ currencies: [], instruments: [] }} />
                    </RB.Modal.Body>
                </RB.Modal>
                : undefined;

            //<RB.Button title='Настроить фильтры' onClick={() => this.updateFilterModal(true)}><RB.Glyphicon glyph="filter" /></RB.Button>

        let mymsgs = this.state.tmessages.filter(x => x.idchat == this.props.sharedChatId);

        let hoverMessage = mymsgs.length > 0 ? mymsgs[mymsgs.length - 1] : undefined;
        let popoverLastMessage = undefined;

        if (hoverMessage) {
            popoverLastMessage =
                <RB.Popover id="popover-lastmsg" title={'Сообщение от ' + hoverMessage.author.lastName + ' ' + hoverMessage.author.firstName } style={{ minWidth: '200px', fontSize: '12px' }}>
                    <div>
                        <span><strong>{'Текст: '}</strong>{hoverMessage.messagetext}</span>
                    </div>
                </RB.Popover>;
        }

        //let chatLi = this.state.sharedChatId && this.state.sharedChatId > 0 ?
        //    <li>
        //        <NavLink to={'#'} onClick={(e) => { e.preventDefault(); this.updateChatModal(true); }} activeClassName='active' >
        //            {'Чат'}
        //            {this.state.tmessages.length > 0 ?
        //                <RB.OverlayTrigger
        //                    trigger={['hover', 'focus']}
        //                    placement="bottom"
        //                    overlay={popoverLastMessage}
        //                    delayShow={500}
        //                >
        //                    <RB.Badge>{this.state.tmessages.length}</RB.Badge>
        //                </RB.OverlayTrigger>
        //                : ''}
        //        </NavLink>
        //    </li>
        //    : undefined;

        let chatNewLi =
            is_deals ?
                <li>
                    <NavLink to={'#'} onClick={(e) => { e.preventDefault(); this.updateChat2Modal(true); }} activeClassName='active' className='linkbtn'>
                        {'Чат'}
                        {this.state.tmessages.length > 0 ?
                            <RB.OverlayTrigger
                                trigger={['hover', 'focus']}
                                placement="bottom"
                                overlay={popoverLastMessage}
                                delayShow={500}
                            >
                                <RB.Badge>{this.state.tmessages.length}</RB.Badge>
                            </RB.OverlayTrigger>
                            : ''}
                    </NavLink>
                </li>
                : undefined;

        let limitsLi =
            is_deals ?
                <li>
                    <NavLink to={'#'} onClick={(e) => { e.preventDefault(); this.updateLimitsModal(true); }} activeClassName='active' className='linkbtn'>
                        {'Лимиты'}
                    </NavLink>
                </li>
                : undefined;

        //onSubmit={(e) => this._logout(e)}
        let logoutForm = <form method="post" id="logoutForm" className="navbar-right">
            
            {chat2Window}
            {limitsWindow}
            <ul className="nav navbar-nav navbar-right" style={{ paddingRight: '28px' }}>
                {/*limitsLi*/}
                {chatNewLi}
                <li>
                    <NavLink to={'/profile'} activeClassName='active' className='linkbtn'>
                        {userDisplay}
                    </NavLink>
                </li>
                <li>
                    <NavLink to={'/logout'} activeClassName='active' className='linkbtn'>
                        <span className='glyphicon glyphicon glyphicon-log-out'></span>Выход
                    </NavLink>
                </li>
            </ul>
        </form>

        //var redirect: string;
        //// const query = new URLSearchParams(this.props.location.search);
        //const returnUrl = this.queryParam('returnUrl', this.props.location.search);
        //const isAbsolute = new RegExp('^([a-z]+://|//)', 'i');
        //if (returnUrl && !isAbsolute.test(returnUrl)) {
        //    redirect = returnUrl;
        //} else {
        //    redirect = "/";
        //}

        //if (redirect === this.props.history.location.pathname)
        //    return null;

        //return (<Grid>
        //    <Redirect to={redirect} />
        //</Grid>);
        return logoutForm;
    }

    public render() {
        let loginfo = this.state.user.identityState.isAuthenticated
            ? this.renderLoggedIn()
            : this.renderLoggedOut();

        return loginfo;


        //<Grid>
        //    <h1>User</h1>
        //    <p>This component demonstrates fetching data from the server and working with URL parameters.</p>
        //    <p>User is authenticated: {this.props.identity.isAuthenticated ? 'Yes! :-)' : 'No :-('}</p>
        //    <p>User email: {this.props.identity.email}</p>
        //</Grid>;

    }
}
